module.exports = __webpack_public_path__ + "img/hr-green-pita-13.c60fe177.png";